import React, { memo } from 'react';
import BlockMarkdown from '../structured/BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems, normalizePriorityLabel, priorityTone } from '../structured/structuredBlockUtils';
import styles from './consultantReport.module.css';

function RecommendationCards({ blocks, renderContext }) {
    const items = blocks.flatMap(block =>
        extractBlockItems(block).map((item, index) => ({
            ...item,
            id: item.id || `${block.id}-rec-${index}`,
            block,
        })),
    );

    if (!items.length) return null;

    return (
        <div className={styles.recommendationCardGrid}>
            {items.map(item => {
                const title = item.title || item.label;
                const description = item.description || item.content || item.markdown;
                const priority = normalizePriorityLabel(item.priority);
                const tone = priorityTone(priority);
                const impact = item.expected_impact || item.impact;
                const effort = item.effort || item.estimated_effort;
                if (!title && !description) return null;

                return (
                    <article key={item.id} className={styles.recommendationCard}>
                        <div className={styles.recommendationCardHeader}>
                            {title ? <h4 className={styles.recommendationCardTitle}>{title}</h4> : null}
                            {priority ? (
                                <span
                                    className={`${styles.recommendationMetaItem} ${styles[`priority${tone}`] || ''}`.trim()}>
                                    {priority}
                                </span>
                            ) : null}
                        </div>
                        {description ? <BlockMarkdown content={description} {...renderContext} /> : null}
                        {impact || effort ? (
                            <div className={styles.recommendationMeta}>
                                {impact ? (
                                    <span className={styles.recommendationMetaItem}>Impact: {impact}</span>
                                ) : null}
                                {effort ? (
                                    <span className={styles.recommendationMetaItem}>Effort: {effort}</span>
                                ) : null}
                            </div>
                        ) : null}
                        <ClaimSupportFooter
                            block={{ ...item.block, citations: item.citations || item.supporting_refs || item.block?.citations }}
                            renderContext={renderContext}
                        />
                    </article>
                );
            })}
        </div>
    );
}

export default memo(RecommendationCards);
